<template>
    <rkm-row>
        <rkm-col>
            <rkm-form-textarea
                label="Mensagem"
                v-model="data.model.mensagemProtocolo"
                rows="4"
                max-rows="4"
                :validations="validations.mensagemProtocolo"
            />
        </rkm-col>
    </rkm-row>
</template>

<script>
export default {
    computed: {
        validations() {

            return {
                mensagemProtocolo: {
                    required: true,
                    max: 500,
                    min: 3,
                },
            }
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>